import { render } from "./ExclusionZones.vue?vue&type=template&id=e528ae70&ts=true"
import script from "./ExclusionZones.vue?vue&type=script&lang=ts"
export * from "./ExclusionZones.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__